import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DashboardBizzDevService } from "../../../shared/services/dashboard-bizz-dev.service";

@Component({
    selector: "app-reminder",
    templateUrl: "./reminder.component.html",
    styleUrls: ["./reminder.component.scss"],
})
export class ReminderComponent implements OnInit {
    dataSource;
    displayedColumns = [
        "code",
        "lastImportDate",
        "importStatus",
        "daysBetweenDates",
        "timeBeforeNextUpdate",
    ];
    @ViewChild(MatSort)
    sort: MatSort;
    constructor(private dashboardService: DashboardBizzDevService) {}

    ngOnInit(): void {
        this.getProvidersStatus();
    }

    getProvidersStatus() {
        this.dashboardService.getProviderStatus().subscribe((value) => {
            this.dataSource = new MatTableDataSource(value);
            if (this.sort) {
                this.dataSource.sort = this.sort;
            }
        });
    }
    monthDiff(providerDate: Date) {
        let months;
        const today = new Date();
        months = (today.getFullYear() - providerDate.getFullYear()) * 12;
        months -= providerDate.getMonth();
        months += today.getMonth();
        return months <= 0 ? 0 : months;
    }
}
